/**
 * The storefront renders the spotlight inside a shadow root, where MUI's
 * emotion-injected `.MuiDrawer-paperAnchor*` rules (which live in
 * `document.head`) never apply. Without explicit positioning the Drawer Paper
 * falls back to static flow at the top-left of the fixed, full-viewport modal
 * root — which is the "drawer renders at the top instead of the bottom" bug on
 * mobile. These styles re-implement MUI's per-anchor positioning inline so the
 * Paper pins to the correct edge regardless of the shadow boundary.
 */
export function getDrawerPaperPositionStyles(
  anchor: "left" | "right" | "top" | "bottom",
): React.CSSProperties {
  switch (anchor) {
    case "bottom":
      return { position: "fixed", top: "auto", bottom: 0, left: 0, right: 0 };
    case "top":
      return { position: "fixed", top: 0, bottom: "auto", left: 0, right: 0 };
    case "left":
      return { position: "fixed", top: 0, bottom: 0, left: 0, right: "auto" };
    case "right":
      return { position: "fixed", top: 0, bottom: 0, left: "auto", right: 0 };
  }
}
